export const dashToSlash = (date: string): string => {
  let newDate = date;
  if (date.includes("T")) {
    // eslint-disable-next-line prefer-destructuring
    newDate = date.split("T")[0];
  }
  return newDate.replaceAll("-", "/");
};

export { default as formatApiDate } from "../../../functions/formatDateWithOffset.function";

export { default as parseDate } from "../../../functions/parseDate.function";
